(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["first-teapot-pathways"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__yixingHomeEventsBound) return;
    window.__yixingHomeEventsBound = true;

    const buildPayload = (eventName, trigger) => {
      const homeRoot = trigger.closest('[data-home-variant]');

      return {
        event: eventName,
        section_id: trigger.getAttribute('data-section-id') || '',
        cro_home_variant: homeRoot ? homeRoot.getAttribute('data-home-variant') || '' : '',
        pathway_index: trigger.getAttribute('data-pathway-index') || '',
        pathway_title: trigger.getAttribute('data-pathway-title') || '',
        link_type: trigger.getAttribute('data-link-type') || '',
        target_id: trigger.getAttribute('href') || ''
      };
    };

    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    document.addEventListener('click', (event) => {
      const trustAnchor = event.target.closest('[data-home-scroll-event]');
      if (trustAnchor) {
        const eventName = trustAnchor.getAttribute('data-home-scroll-event');
        if (!eventName) return;

        const targetId = (trustAnchor.getAttribute('href') || '').replace('#', '');
        const target = targetId ? document.getElementById(targetId) : null;

        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          target.focus({ preventScroll: true });
        }

        emitPayload(buildPayload(eventName, trustAnchor), 'yixing:home-trust-anchor-click');
        return;
      }

      const pathwayLink = event.target.closest('[data-pathway-event]');
      if (!pathwayLink) return;

      const eventName = pathwayLink.getAttribute('data-pathway-event');
      if (!eventName) return;

      emitPayload(buildPayload(eventName, pathwayLink), 'yixing:home-pathway-click');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["path-bottom-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-path-bottom-cta-root]');
    if (!roots.length) return;
    const scrollEnabledPaths = ['first-yixing-teapot', 'by-tea-type', 'by-budget', 'gift-purchase'];

    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    const scrollToProducts = (pathHandle) => {
      const productsRoot = document.querySelector(
        '[data-path-products-root][data-path-handle="' + pathHandle + '"]'
      );
      const productsGrid = productsRoot && productsRoot.querySelector('[data-path-products-grid]');

      if (!productsRoot || !productsGrid) return false;

      const gridTop = productsGrid.getBoundingClientRect().top + window.scrollY;
      const scrollTop = Math.max(0, gridTop - 32);

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });

      return true;
    };

    roots.forEach((root) => {
      if (root.dataset.pathBottomCtaBound === 'true') return;
      root.dataset.pathBottomCtaBound = 'true';

      const pathHandle = root.getAttribute('data-path-handle') || '';
      const sectionId = root.getAttribute('data-section-id') || '';
      const ctaType = root.getAttribute('data-cta-type') || '';

      root.querySelectorAll('[data-path-bottom-cta]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const ctaVariant = link.getAttribute('data-cta-variant') || '';

          if (scrollEnabledPaths.includes(pathHandle) && ctaVariant === 'primary') {
            const didScroll = scrollToProducts(pathHandle);
            if (didScroll) event.preventDefault();
          }

          emitPayload(
            {
              event: 'cro_path_cta_click',
              path_handle: pathHandle,
              section_id: sectionId,
              cta_type: ctaType,
              cta_variant: ctaVariant,
              target_id: link.getAttribute('href') || ''
            },
            'yixing:path-bottom-cta-click'
          );
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["path-education"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-path-education-root]');
    if (!roots.length) return;

    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    roots.forEach((root) => {
      if (root.dataset.pathEducationBound === 'true') return;
      root.dataset.pathEducationBound = 'true';

      const pathHandle = root.getAttribute('data-path-handle') || '';
      const sectionId = root.getAttribute('data-section-id') || '';

      root.querySelectorAll('[data-path-education-item]').forEach((item, index) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          const title = item.querySelector('h3');
          emitPayload(
            {
              event: 'cro_path_education_expand',
              path_handle: pathHandle,
              section_id: sectionId,
              block_index: index + 1,
              block_title: title ? title.textContent.trim() : ''
            },
            'yixing:path-education-expand'
          );
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["path-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-path-faq-root]');
    if (!roots.length) return;

    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    roots.forEach((root) => {
      if (root.dataset.pathFaqBound === 'true') return;
      root.dataset.pathFaqBound = 'true';

      const pathHandle = root.getAttribute('data-path-handle') || '';
      const sectionId = root.getAttribute('data-section-id') || '';

      root.querySelectorAll('[data-path-faq-item]').forEach((item, index) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          const question = item.querySelector('summary span');
          emitPayload(
            {
              event: 'cro_path_faq_open',
              path_handle: pathHandle,
              section_id: sectionId,
              faq_index: index + 1,
              faq_question: question ? question.textContent.trim() : ''
            },
            'yixing:path-faq-open'
          );
        });
      });

      const cta = root.querySelector('[data-path-faq-cta]');
      if (cta) {
        cta.addEventListener('click', () => {
          emitPayload(
            {
              event: 'cro_path_cta_click',
              path_handle: pathHandle,
              section_id: sectionId,
              cta_source: 'faq',
              target_id: cta.getAttribute('href') || ''
            },
            'yixing:path-faq-cta-click'
          );
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["path-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-path-page-root]');
    if (!roots.length) return;
    const scrollEnabledPaths = ['first-yixing-teapot', 'by-tea-type', 'by-budget', 'gift-purchase'];

    if (!window.__yixingPathPageViews) {
      window.__yixingPathPageViews = {};
    }

    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    const scrollToProducts = (pathHandle) => {
      const productsRoot = document.querySelector(
        '[data-path-products-root][data-path-handle="' + pathHandle + '"]'
      );
      const productsGrid = productsRoot && productsRoot.querySelector('[data-path-products-grid]');

      if (!productsRoot || !productsGrid) return false;

      const gridTop = productsGrid.getBoundingClientRect().top + window.scrollY;
      const scrollTop = Math.max(0, gridTop - 32);

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });

      return true;
    };

    roots.forEach((root) => {
      if (root.dataset.pathHeroBound === 'true') return;
      root.dataset.pathHeroBound = 'true';

      const pathHandle = root.getAttribute('data-path-handle') || '';
      const sectionId = root.getAttribute('data-section-id') || '';

      if (pathHandle && !window.__yixingPathPageViews[pathHandle]) {
        window.__yixingPathPageViews[pathHandle] = true;
        emitPayload(
          {
            event: 'cro_path_page_view',
            path_handle: pathHandle,
            section_id: sectionId,
            page_path: window.location.pathname
          },
          'yixing:path-page-view'
        );
      }

      root.querySelectorAll('[data-path-hero-cta]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const ctaVariant = link.getAttribute('data-cta-variant') || '';

          if (scrollEnabledPaths.includes(pathHandle) && ctaVariant === 'primary') {
            const didScroll = scrollToProducts(pathHandle);
            if (didScroll) event.preventDefault();
          }

          emitPayload(
            {
              event: 'cro_path_hero_cta_click',
              path_handle: pathHandle,
              section_id: sectionId,
              cta_variant: ctaVariant,
              target_id: link.getAttribute('href') || ''
            },
            'yixing:path-hero-cta-click'
          );
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["path-trust"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-path-trust-root]');
    if (!roots.length) return;

    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    roots.forEach((root) => {
      if (root.dataset.pathTrustBound === 'true') return;
      root.dataset.pathTrustBound = 'true';

      const pathHandle = root.getAttribute('data-path-handle') || '';
      const sectionId = root.getAttribute('data-section-id') || '';
      const details = root.querySelector('[data-path-trust-details]');
      const cta = root.querySelector('[data-path-trust-cta]');

      if (details) {
        details.addEventListener('toggle', () => {
          if (!details.open) return;

          emitPayload(
            {
              event: 'cro_path_trust_expand',
              path_handle: pathHandle,
              section_id: sectionId
            },
            'yixing:path-trust-expand'
          );
        });
      }

      if (cta) {
        cta.addEventListener('click', () => {
          emitPayload(
            {
              event: 'cro_path_cta_click',
              path_handle: pathHandle,
              section_id: sectionId,
              cta_source: 'trust',
              target_id: cta.getAttribute('href') || ''
            },
            'yixing:path-trust-cta-click'
          );
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["path-visual-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-path-visual-root]');
    if (!roots.length) return;

    const normalizeList = (text) => {
      return (text || '')
        .split(',')
        .map((item) => item.trim().toLowerCase())
        .filter((item) => item.length > 0);
    };

    const buildPayload = (card, pathHandle, sectionId, clickEvent) => {
      const entryLimit = parseInt(card.getAttribute('data-default-limit') || '8', 10);
      const entryExpanded = parseInt(card.getAttribute('data-expanded-limit') || '12', 10);
      let collectionProducts = [];
      let manualProducts = [];

      try {
        const rawManualProducts = card.querySelector('[data-entry-manual-products]');
        manualProducts = JSON.parse((rawManualProducts && rawManualProducts.textContent) || '[]');
      } catch (error) {
        manualProducts = [];
      }

      try {
        const rawProducts = card.querySelector('[data-entry-collection-products]');
        collectionProducts = JSON.parse((rawProducts && rawProducts.textContent) || '[]');
      } catch (error) {
        collectionProducts = [];
      }

      return {
        event: clickEvent,
        path_handle: pathHandle,
        section_id: sectionId,
        target_id: card.getAttribute('data-card-title') || '',
        card_title: card.getAttribute('data-card-title') || '',
        entry_key: card.getAttribute('data-entry-key') || '',
        entry_title: card.getAttribute('data-entry-title') || '',
        entry_description: card.getAttribute('data-entry-description') || '',
        collection_handle: card.getAttribute('data-collection-handle') || '',
        manual_product_handles: normalizeList(card.getAttribute('data-manual-product-handles') || ''),
        manual_products: Array.isArray(manualProducts) ? manualProducts : [],
        collection_product_handles: normalizeList(card.getAttribute('data-collection-product-handles') || ''),
        collection_products: Array.isArray(collectionProducts) ? collectionProducts : [],
        product_tags: normalizeList(card.getAttribute('data-product-tags') || ''),
        fallback_tags: normalizeList(card.getAttribute('data-fallback-tags') || ''),
        sort_rule: card.getAttribute('data-sort-rule') || 'score_then_price_asc',
        default_limit: Number.isNaN(entryLimit) ? 8 : entryLimit,
        expanded_limit: Number.isNaN(entryExpanded) ? 12 : entryExpanded,
        view_more_url: card.getAttribute('data-view-more-url') || '',
        view_more_text: card.getAttribute('data-view-more-text') || 'View more'
      };
    };

    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    const updatePanel = (root, nextCard) => {
      const panel = root.querySelector('[data-path-visual-panel]');
      if (!panel || !nextCard) return;

      const labelNode = panel.querySelector('[data-path-visual-panel-label]');
      const titleNode = panel.querySelector('[data-path-visual-panel-title]');
      const bodyNode = panel.querySelector('[data-path-visual-panel-body]');
      const resultNode = panel.querySelector('[data-path-visual-panel-result]');

      if (labelNode) labelNode.textContent = nextCard.getAttribute('data-entry-label') || '';
      if (titleNode) titleNode.textContent = nextCard.getAttribute('data-card-title') || '';
      if (bodyNode) bodyNode.textContent = nextCard.getAttribute('data-card-body') || '';
      if (resultNode) resultNode.textContent = nextCard.getAttribute('data-result-label') || 'Update picks below';
    };

    const setActiveCard = (root, nextCard) => {
      const cards = Array.from(root.querySelectorAll('[data-path-entry-card]'));
      cards.forEach((card) => {
        const active = card === nextCard;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      updatePanel(root, nextCard);
    };

    const onClickCard = (event, root, pathHandle, sectionId) => {
      const card = event.currentTarget;
      const enabled = card.getAttribute('data-is-enabled') !== 'false' && !card.disabled;
      if (!enabled) return;

      event.preventDefault();
      const payload = buildPayload(card, pathHandle, sectionId, 'cro_path_visual_card_click');

      setActiveCard(root, card);
      emitPayload(payload, 'yixing:path-entry-change');
      emitPayload(payload, 'yixing:path-visual-card-click');
    };

    roots.forEach((root) => {
      if (root.dataset.pathVisualBound === 'true') return;
      root.dataset.pathVisualBound = 'true';

      const pathHandle = root.getAttribute('data-path-handle') || '';
      const sectionId = root.getAttribute('data-section-id') || '';
      const cards = Array.from(root.querySelectorAll('[data-path-entry-card]'));

      cards.forEach((card) => {
        card.addEventListener('click', (event) => onClickCard(event, root, pathHandle, sectionId));
      });

      const initialKey = (root.getAttribute('data-initial-entry-key') || '').trim().toLowerCase();
      const initialCard =
        cards.find((card) => card.getAttribute('data-entry-key') === initialKey) || cards[0];

      if (!initialCard) return;

      setActiveCard(root, initialCard);
      const payload = buildPayload(initialCard, pathHandle, sectionId, 'cro_path_entry_initial');
      emitPayload(payload, 'yixing:path-entry-change');
      emitPayload(payload, 'yixing:path-visual-card-click');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-maker-trust-card"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const emitPayload = (payload, customEventName) => {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(
        new CustomEvent(customEventName, {
          detail: payload
        })
      );
    };

    const buildBasePayload = (root) => ({
      section_id: root.getAttribute('data-section-id') || '',
      cro_pdp_variant: root.getAttribute('data-pdp-variant') || '',
      product_id: root.getAttribute('data-product-id') || '',
      product_handle: root.getAttribute('data-product-handle') || '',
      trust_branch: root.getAttribute('data-trust-branch') || ''
    });

    const bindRoot = (root) => {
      if (!root || root.dataset.pdpEventsBound === 'true') return;
      root.dataset.pdpEventsBound = 'true';

      const trustDetails = root.querySelector('[data-pdp-trust-details]');
      if (trustDetails) {
        trustDetails.addEventListener('toggle', () => {
          if (!trustDetails.open) return;

          emitPayload(
            {
              event: 'cro_pdp_trust_expand',
              ...buildBasePayload(root)
            },
            'yixing:pdp-trust-expand'
          );
        });
      }

      root.querySelectorAll('[data-pdp-shipping-faq]').forEach((faqItem) => {
        faqItem.addEventListener('toggle', () => {
          if (!faqItem.open) return;

          emitPayload(
            {
              event: 'cro_pdp_shipping_faq_expand',
              faq_topic: faqItem.getAttribute('data-faq-topic') || '',
              ...buildBasePayload(root)
            },
            'yixing:pdp-shipping-faq-expand'
          );
        });
      });
    };

    const bindRoots = () => {
      document.querySelectorAll('[data-pdp-event-root]').forEach(bindRoot);
    };

    if (!window.__yixingPdpTrustDocumentBound) {
      window.__yixingPdpTrustDocumentBound = true;

      document.addEventListener(
        'submit',
        (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

          const root = document.querySelector('[data-pdp-event-root]');
          if (!root) return;
          if (!form.closest('product-info')) return;

          emitPayload(
            {
              event: 'cro_pdp_add_to_cart',
              variant_id: form.querySelector('[name="id"]')?.value || '',
              ...buildBasePayload(root)
            },
            'yixing:pdp-add-to-cart'
          );
        },
        true
      );

      document.addEventListener('click', (event) => {
        const jumpTrigger = event.target.closest('[data-add-to-cart-jump]');
        if (!jumpTrigger) return;

        const submitButton =
          document.querySelector('product-info .product-form__submit:not([disabled])') ||
          document.querySelector('product-info .product-form__submit');

        if (!submitButton) return;

        event.preventDefault();
        submitButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        submitButton.focus({ preventScroll: true });
      });

      document.addEventListener('shopify:section:load', bindRoots);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindRoots, { once: true });
    } else {
      bindRoots();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["task7-hero-quick-path"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_ID = '{{ section.id }}';
    if (window.__yixingTask7Bound) return;
    window.__yixingTask7Bound = true;

    const buildPayload = (eventName, node) => ({
      event: eventName,
      section_id: SECTION_ID,
      target_id: node.getAttribute('href') || '',
      target_text: node.getAttribute('data-pathway-title') || '',
      link_type: node.getAttribute('data-link-type') || '',
      cro_home_variant: '{{ section.settings.variant_label | escape }}',
      entry_key: node.getAttribute('data-entry-key') || '',
      entry_title: node.getAttribute('data-entry-title') || '',
      entry_description: node.getAttribute('data-entry-description') || '',
      product_tags: node.getAttribute('data-product-tags') || '',
      fallback_tags: node.getAttribute('data-fallback-tags') || '',
      sort_rule: node.getAttribute('data-sort-rule') || '',
      default_limit: node.getAttribute('data-default-limit') || '8',
      expanded_limit: node.getAttribute('data-expanded-limit') || '12',
      view_more_url: node.getAttribute('data-view-more-url') || '',
      view_more_text: node.getAttribute('data-view-more-text') || '',
      path_products_anchor: node.getAttribute('data-path-products-anchor') || ''
    });

    document.addEventListener('click', (ev) => {
      const trigger = ev.target.closest('[data-pathway-event]');
      if (!trigger) return;
      const evt = trigger.getAttribute('data-pathway-event');
      if (!evt) return;

      const payload = buildPayload(evt, trigger);

      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }
      document.dispatchEvent(new CustomEvent('yixing:home-pathway-click', { detail: payload }));

      if (payload.entry_key) {
        ev.preventDefault();

        document.dispatchEvent(
          new CustomEvent('yixing:path-entry-change', {
            detail: {
              explicit_config: true,
              key: payload.entry_key,
              entry_key: payload.entry_key,
              entry_title: payload.entry_title,
              entry_description: payload.entry_description,
              product_tags: payload.product_tags,
              fallback_tags: payload.fallback_tags,
              sort_rule: payload.sort_rule,
              default_limit: payload.default_limit,
              expanded_limit: payload.expanded_limit,
              view_more_url: payload.view_more_url,
              view_more_text: payload.view_more_text
            }
          })
        );

        const targetId = payload.path_products_anchor;
        const target = targetId ? document.getElementById(targetId) : null;
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
